import React from "react";

export default function IsInStock(props) {
  // PROPS COMING FROM PriceOffer
  const { product } = props;

  return (
    <>
      {product.defaultCountInStock ||
      Array.from(product.skus.map((sku) => sku.countInStock)).reduce(
        (a, c) => a + c,
        0
      ) > 0 ? (
        <div className="countinstock txtcenter">
          <span className="success">Stokta Var</span>
        </div>
      ) : (
        <div className="countinstock txtcenter">
          <span className="danger">Stokta Yok</span>
        </div>
      )}
    </>
  );
}
